module.exports = __webpack_public_path__ + "img/zdrjc-bg.ccca5e34.png";